<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a>Schedules</a></li>
      </ol>
    </div>
    <div class="sub-navbar">
      <div class="sub-left">
        <div class="sub-left-inlft">
          <ul class="left-links over-drop">
            <li><a href="#" class="btn sched-btn ">Scheduling Name</a></li>
            <li>
              <div class="custom-input-group">
                <span class="custom-input-opner">
                  <router-link :to="'/schedule/publish/'+roster_schedule_id+'/weeks'"
                            title="Click here" class="text-capitalize" >{{ schedule_name }}</router-link>
                  <span class="edit-btn"><i class="ico-pencil" @click="scheduleNameBtnClick"></i></span>
                </span>

                  <div class="input-group" v-show="scheduleNameShow">
                    <input type="text" class="form-control text-capitalize" v-model="schedule_name">
                    <div class="input-group-append">
                      <button  class="btn btn-info" @click="scheduleNameSaveBtnClick(roster_schedule_id)" type="button">Save</button>
                      <button class="btn btn-danger" @click="scheduleNameCancelBtnClick" type="button">Cancel</button>

                    </div>
                  </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="sub-right extra">
        <ul class="right-links">
          <li class="sub-left-inrgt p-0">
            <job-roles-filter :jobTypes="jobTypes" @selectedShift="filterFunction"></job-roles-filter>
          </li>
          <li>
            <a href="javascript:void(0);" data-toggle="modal"
               data-target="#publishModel" class="btn btn-primary"><span class="ico ico-edit"></span>Edit</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="scrol-main-box">
      <div class="main-box two-column">
        <div class="left-side mb-10"  v-for="(week,weekKey) in byWeekly">
          <div class="start-week">





            <h5 v-if="week==1">Week From {{ startWeek | moment("MMM D, YYYY") }}</h5>
            <h5 v-if="week>1">Week From {{ weekNoDate[week][0] | moment("MMM D, YYYY") }}</h5>
          </div>
          <ul class="nav nav-tabs week-tabs" role="tablist">
            <li v-for="(day,dayIndex) in weeksDatesByWeek[week]" :key="day" :data-day="day" v-if="day>=startWeek && day<=endWeek">
              <a  :class="day==dateParam ?'active':''" style="color: #fd4f50" role="tab" data-toggle="tab" :href="'#day0'+week+dayIndex" v-if="day===currentDate" >
                Today,{{ day | moment(' D MMM') }} <span class="go-week" @click="goToweek()">Go to week</span>
              </a>

              <a :class="day==dateParam ?'active':''" role="tab" data-toggle="tab" :href="'#day0'+week+dayIndex"  v-else>
                {{ day | moment('ddd, D MMM') }}
                <span class="go-week" @click="goToweek()">Go to week</span>
              </a>
            </li>
            <li v-else></li>
          </ul>

              <div class="tab-content" style="position: relative">
                 <span class="spinnerCustom">
                     <clip-loader :loading="loadingSpinMain" :size="sizeMain" :color="spinnerColor"></clip-loader>
                </span>
                <div  v-for="(day,keyIndex) in weeksDatesByWeek[week]" :keyIndex="day"
                      :class="day===dateParam ?' active':''" class="tab-pane"  :id="'day0'+week+keyIndex" role="tabpanel">

  <!-- data not found -->
                  <div class="sheduel-block-hold">
                    <div class="sheduel-block-lft">
                      <div class="sheduel-date-list" v-if="newarray[week+day].length>0">
                    <div  v-for="(info,index) in newarray[week+day]" :key="index" class="sheduel-li">
                      <div class="sheduel-li-head">
                        <time class="date" datetime="2015-06-15"  v-bind:class="{ 'opacity-1' : selectedShift == info.job_role_id}">
                          <i class="fas fa-cog"></i> {{
                            employeeShiftHours[day + info.start_time + info.end_time].start_time.split(':')[0] + ":" + employeeShiftHours[day + info.start_time + info.end_time].start_time.split(':')[1]
                          }} -
                          {{
                            employeeShiftHours[day + info.start_time + info.end_time].end_time.split(':')[0] + ":" + employeeShiftHours[day + info.start_time + info.end_time].end_time.split(':')[1]
                          }}
                        </time>
                      </div>
                      <div v-bind:class="{ 'filter-active-cus' : filterActiveCus == true }">
                        <div class="sheduel-li-row"    v-if="employeeShiftHours[day+info.start_time+info.end_time]"
                            v-for="(item,keyInt) in  employeeShiftHours[day+info.start_time+info.end_time].shift"
                            @click="selectShiftItem(day+info.start_time+info.end_time+keyInt)"
                             v-bind:class="[getRespondClassActiveItem(day,info,keyInt,activeItem),  getRespondClassMatchRole(selectedShift,item.jobRole.id ) ,
                                 getRespondClassMatchAvailable(selectedShift,'available_'+item.is_shift_available ) ,
                                 getRespondClassMatchOnDuty(selectedShift,'on_duty_1',item,day,currentDate)
                                   ]"
                        >
<!--
<div class="sheduel-li-row"    v-if="employeeShiftHours[day+info.start_time+info.end_time]"
                            v-for="(item,keyInt) in  employeeShiftHours[day+info.start_time+info.end_time].shift"
                            @click="selectShiftItem(day+info.start_time+info.end_time+keyInt)"
                             v-bind:class="{ 'active': day+info.start_time+info.end_time+keyInt === activeItem,
                              'matchShiftClass' : selectedShift === item.jobRole.id || selectedShift == 'available_'+item.is_shift_available}"
                        >
-->
                          <div class="li-row-lft">
                            <div class="a">
                              <div class="profile-img" v-if="item.employee">
                                <img width="30" height="30"  :src="item.employee.gender == 'female'? require('@/assets/images/female-avatar.jpg'): require('@/assets/images/male-avatar.png') " alt="image description" >
                              </div>
                              <div class="profile-img" v-else>
                                <img width="30" height="30"  :src="require('@/assets/images/male-avatar.png') " alt="image description" >
                              </div>
                              <div class="profile-det">
<!--                                {{item.attendances[2]}}-->
<!--                                {{ item.attendances[(item.attendances.length)-1].punch_in_time}}-->
                                <strong class="name text-capitalize" v-if="item.employee">  <router-link  :to="'/employee/profile/'+item.employee.uuid">{{ item.employee.name }}</router-link>
                                  <span v-if="item.is_shift_available>0" class="badge badge-success">Available</span>

                                  <small class="ml-5"  v-if="item.attendances" v-for="attendance in item.attendances">  ({{ timeFormat(attendance.punch_in_time) }} {{attendance.punch_out_time?' - '+timeFormat(attendance.punch_out_time) :' - --:--'}})</small>
                                </strong>
                                <strong class="name text-capitalize" v-else>  Open Shift <span v-if="item.is_shift_available>0" class="badge badge-success">Available</span></strong>

                                <span class="break" v-if="item.break_time">Break: {{ item.break_time }} Minutes</span>
                                <span class="emp-designation text-capitalize">
                                  <span>
                                    <i class="ico ico-fill-circle" :style="'color:'+item.jobRole.color" :data-color="item.jobRole.color"
                                      :class="item.attendance ? item.attendance.punch_in_time && item.attendance.punch_out_time==null && day===currentDate ? 'blink' : 'unBlink':''">
                                    </i>{{ item.jobRole.name }}
                                  </span>
                                </span>
                                <div class="pr-det-totol">
                                  <span class="total-tag-sm" v-if="item.employee">
                                    <span v-if="item.employee.employment_type == 'full-time'">
                                      {{ currencySymbol }} {{ item.emp_hourly_rate ? item.emp_hourly_rate.toFixed(2) : 0 }} / hr
                                    </span>
                                    <span class="total-tag-sm" v-else>
                                      {{ currencySymbol }} {{ item.employee.hourly_rate }} / hr
                                    </span>
                                  </span>

                                  <span v-if="item.employee">
                                    <span v-if="item.employee.employment_type == 'full-time'">
                                      {{currencyAmountFormat(hourlyPriceCalculate(item.emp_hourly_rate,item.start_time,item.end_time,item.employee.name,0,item.date))}} {{ currencySymbol }}
                                    </span>
                                    <span class="total-tag-sm" v-else>
                                      {{currencyAmountFormat(hourlyPriceCalculate(item.employee.hourly_rate,item.start_time,item.end_time,item.employee.name,0,item.date))}} {{ currencySymbol }}
                                    </span>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="li-row-rgt shiftActionBtn" v-show="day+info.start_time+info.end_time+keyInt === activeItem"  v-bind:class="{ 'activeActionShift': day+info.start_time+info.end_time+keyInt === activeItem}">
                            <div class="data-buttons data-buttons-shift-action" role="tablist">
                              <a href="javascript:void(0);" @click="selectShiftActionBtn('handOverShift'+day+info.start_time+info.end_time+keyInt,item.id,item.employee,item.date,item.jobRole.id,info.start_time,info.end_time,'handover')"  class="data-btn"><i class="fas fa-sync"></i> Hand over shift</a>
                              <a href="javascript:void(0);" @click="selectShiftActionBtn('makeItAvailable'+day+info.start_time+info.end_time+keyInt,item.id,item.employee,item.date,item.jobRole.id,info.start_time,info.end_time,'makeitavailable')"  class="data-btn" v-if="item.is_shift_available==0"><i class="fas fa-user-clock"></i> Make shift available</a>
                              <a href="javascript:void(0);" @click="selectShiftActionBtn('editShiftTab'+day+info.start_time+info.end_time+keyInt,item.id,item.employee,item.date,item.jobRole.id,info.start_time,info.end_time,'editshift')"  role="tab" class="data-btn"><i class="fas fa-cog"></i> Edit Shift</a>
                              <a href="javascript:void(0);" @click="selectShiftActionBtn('attendanceMarkTab'+day+info.start_time+info.end_time+keyInt,item.id,item.employee,item.date,item.jobRole.id,info.start_time,info.end_time,'attendanceMark')"  role="tab" class="data-btn"><i class="fas fa-cog"></i>Attendance Mark</a>

                              <a href="javascript:void(0);" @click="deleteSchedule(item.id)"  role="tab" class="data-btn bg-danger text-white"><i class="fas fa-cog"></i> Delete Shift</a>
                            </div>
                            <div class="tab-content" v-show="mainShiftActionTab">
                              <div class="open-box hand-over-bx " v-show="'handOverShift'+day+info.start_time+info.end_time+keyInt === shiftActionTab" >
                                <div class="open-box-head">
                                  <strong class="title">Hand over shift</strong>
                                  <a href="javascript:void(0);" class="cancel-btn" @click="cancelAction">Cancel</a>
                                </div>
                                <div class="open-box-body">
                                  <p><strong>want to hand over the shift</strong></p>
                                  <p>You are about to hand over the shift from one employee to another. You can also remove the employee from the shift.</p>
                                  <div class="select-custom">
                                    <select class="form-control text-capitalize" v-model="employee_id">
                                      <option v-for="employee in jobTypesEmployees.employees" :value="employee.employee.id" class="text-capitalize">{{employee.employee.name}}</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="open-box-tfoot">
                                  <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="customCheck1">
                                    <label class="custom-control-label" for="customCheck1">Change ownership without permission</label>
                                  </div>
                                  <a href="javascript:void(0);"  @click="handOverShiftFun" class="btn btn-light">Hand over shift</a>
                                </div>
                              </div>
                              <div class="open-box make-shift-bx " v-show="'makeItAvailable'+day+info.start_time+info.end_time+keyInt === shiftActionTab">
                                <div class="open-box-head">
                                  <strong class="title">Hand over shift</strong>
                                  <a href="javascript:void(0);" class="cancel-btn" @click="cancelAction">Cancel</a>
                                </div>
                                <div class="open-box-body">
                                  <p><strong>Make shift available</strong></p>
                                  <p>Want to make your shift available to others? It's yours until someone accepts the shift.</p>
                                  <div class="text-right">
                                    <a href="javascript:void(0);" @click="makeItAvailableShiftFun(item.id)" class="btn btn-light">Yes please. Make it available.</a>
                                  </div>
                                </div>
                              </div>
                              <div class="open-box edit-shift-bx " v-show="'editShiftTab'+day+info.start_time+info.end_time+keyInt === shiftActionTab">
                                <div class="open-box-head">
                                  <strong class="title">Edit shift</strong>
                                  <a href="javascript:void(0);" class="cancel-btn" @click="cancelAction">Cancel</a>
                                </div>
                                <div class="open-box-body">
                                  <p>As an admin you have permission to always edit shifts.</p>
                                  <div class="form-row form-group align-items-center">
                                    <label  class="col-md-4">Flexible Time</label>
                                    <div class="col-md-8">
                                      <div class="form-row flex-nowrap">
                                        <div class="col-5 pr-0">
<!--                                          <input type="checkbox" v-model="scheduleForm.start_time" class="form-control">-->
                                          <input type="checkbox" v-model="scheduleForm.is_floating_shift" :true-value="1" :false-value="0">
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="form-row form-group align-items-center">
                                    <label  class="col-md-4">Timeblock</label>
                                    <div class="col-md-8">
                                      <div class="form-row flex-nowrap">
                                        <div class="col-5 pr-0"><input type="time" v-model="scheduleForm.start_time" class="form-control"></div>
                                        <div class="col-1 text-center">-</div>
                                        <div class="col-5 pl-0"><input type="time" v-model="scheduleForm.end_time"  class="form-control"></div>
                                      </div>
                                    </div>
                                  </div>
    <!--                              <div class="form-row form-group">
                                    <label  class="col-md-6"></label>
                                    <div class="col-md-6">
                                      <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="customCheck2">
                                        <label class="custom-control-label" for="customCheck2">Closing shift</label>
                                      </div>
                                    </div>
                                  </div>-->
                                  <div class="form-row form-group">
                                    <label  class="col-md-4">Break</label>
                                    <div class="col-md-8 select-custom">
                                      <select class="form-control  " v-model="scheduleForm.break_time">
                                        <option value="">Select</option>
                                        <option :value="20">20 Min</option>
                                        <option :value="30">30 Min</option>
                                        <option :value="40">40 Min</option>
                                        <option :value="60">60 Min</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="form-row form-group">
                                    <label  class="col-md-4">Job Roles</label>
                                    <div class="col-md-8 select-custom">
                                      <select  v-model="scheduleForm.job_role_id"
                                               @change="getEmployeeByJobRoleChange($event)" class="form-control  ">
                                        <option>Select</option>
                                        <option v-if="jobTypes.length>0" v-for="value in jobTypes" :value="value.id">
                                          {{ value.name }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="form-row form-group">
                                    <label  class="col-md-4">Employees</label>
                                    <div class="col-md-8 select-custom">
                                      <select class="form-control" v-model="scheduleForm.employee_id">
                                        <option value="">Open Shift</option>
                                        <optgroup :label="'Employees with the Job Role:'">
                                          <option :value="jobTypesEmployees.adminDetail.employee.id" v-if="jobTypesEmployees.adminDetail">{{jobTypesEmployees.adminDetail.employee.name}}</option>
                                          <option class="text-capitalize" v-if="jobTypesEmployees.employees.length>0"
                                                  v-for="value in jobTypesEmployees.employees"
                                                  :value="value.employee.id">{{ value.employee.name }}
                                          </option>
                                        </optgroup>
    <!--                                    <optgroup :label="'Employees without the Job Role:'">
                                          <option class="text-capitalize" v-if="withoutjobTypesEmployees.length>0"
                                                  v-for="value in withoutjobTypesEmployees"
                                                  :value="value.employee.id">{{ value.employee.name }}
                                          </option>
                                        </optgroup>-->
                                      </select>
                                    </div>
                                  </div>

                                  <div class="form-row form-group">
                                    <label  class="col-md-4">Note</label>
                                    <div class="col-md-8">
                                      <input class="form-control"  v-model="scheduleForm.comment" type="text" placeholder="Add a note">
                                    </div>
                                  </div>
                                  <div class="d-flex justify-content-between align-items-center">
                                    <a href="javascript:void(0);" class="btn btn-link text-danger" @click="deleteSchedule(item.id)">Delete shift</a>
                                    <a href="javascript:void(0);" class="btn btn-light" @click="updateSchedule(item.id)">Save changes</a>
                                  </div>

                                </div>
                              </div>
                              <div class="open-box edit-shift-bx " v-show="'attendanceMarkTab'+day+info.start_time+info.end_time+keyInt === shiftActionTab">
                                <div class="open-box-head">
                                  <strong class="title">Attendance mark</strong>
                                  <a href="javascript:void(0);" class="cancel-btn" @click="cancelAction">Cancel</a>
                                </div>
                                <div class="open-box-body">
                                  <p>As an admin you have permission to always attendance mark this shifts.</p>
                                  <div class="form-row form-group align-items-center">
                                    <!-- <label  class="col-md-4">Punch-in/Punch-out</label> -->
                                    <div class="col-md-12">
                                      <div class="form-row flex-nowrap pb-5" v-for="(atend,index) of attendanceForm" :key="index" v-show="attendanceForm && attendanceForm.length>0">
                                        <!-- <div class="" > -->
                                          <div class="col-3 pl-0 pr-1">
                                            <label>Punch In</label>
                                            <input type="time" class="form-control" v-model="atend.punchIn" @change="validateTime($event,'start')" />
                                          </div>
                                          <div class="col-3 pl-0 pr-1">
                                            <label>Punch Out</label>
                                            <input type="time" class="form-control" v-model="atend.punchOut" @change="validateTime($event,'end')" />
                                          </div>
                                          <div class="col-3 pl-0 pr-1">
                                            <label>Note In</label>
                                            <input type="text" class="form-control" v-model="atend.punch_in_note" />
                                          </div>
                                          <div class="col-3 pl-0 pr-1">
                                            <label>Note Out</label>
                                            <input type="text" class="form-control" v-model="atend.punch_out_note" />
                                          </div>
                                      </div>
                                      <div class="form-row flex-nowrap pb-5" v-show="attendanceForm && attendanceForm.length==0">
                                          <div class="col-3 pl-0 pr-1">
                                            <label>Punch In</label>
                                            <input type="time" class="form-control"  v-model="punchInTime" @change="validateTime($event,'start')" />
                                          </div>
                                          <div class="col-3 pl-0 pr-1">
                                            <label>Punch Out</label>
                                            <input type="time" class="form-control" v-model="punchOutTime" @change="validateTime($event,'end')" />
                                          </div>
                                          <div class="col-3 pl-0 pr-1">
                                            <label>Note In</label>
                                            <input type="text" class="form-control" v-model="punchInNote" />
                                          </div>
                                          <div class="col-3 pl-0 pr-1">
                                            <label>Note Out</label>
                                            <input type="text" class="form-control" v-model="punchOutNote" />
                                          </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="inputs-holder mt-4">
                                    <div class="field-col">
                                      <label>Break Time</label>
                                      <div class="nav-selectdrop">
                                        <select
                                          id="inputState"
                                          class="form-control"
                                          v-model="scheduleForm.break_time"
                                        >
                                          <option value="">Select</option>
                                        <option :value="20">20 Min</option>
                                        <option :value="30">30 Min</option>
                                        <option :value="40">40 Min</option>
                                        <option :value="60">60 Min</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-text="errorText" class="text-red pt-10"></div>
                                  <div class="d-flex justify-content-between align-items-center pt-15">
                                    <a href="javascript:void(0);" class="cancel-btn" @click="cancelAction">Cancel</a>
                                    <button type="button" class="btn btn-light" :disabled="saveBtnDisable" @click="attendanceMarkShift(item.id)">Attendance Mark</button>
                                  </div>

                                </div>
                              </div>
                            </div>
                            </div>
                          </div>
                        </div>
                      <div class="sheduel-li-tfoot">
                        <a href="javascript:void(0);" @click="addNewShift(day,info.start_time,info.end_time)" class="btn btn-link"><i class="ico-user"></i> + Add New Shift</a>
                      </div>
                    </div>
                  </div>
                      <div class="sheduel-date-list" v-else >
                        <div class="sheduel-li" >
                          <div class="sheduel-li-head">
                            <strong>This day is empty. No work to find here.</strong>
                          </div>
                          <div class="sheduel-li-tfoot">
                            <a href="javascript:void(0);" @click="addNewShift(day,'','')" class="btn btn-link"><i class="ico-user"></i> + Add New Shift</a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <messages :scheduleDate="day"></messages>

                  </div>
                </div>

              </div>
            </div>
  <!--          <div class="sheduel-msg">
              <div class="sheduel-msg-head">
                <strong>Todays messages</strong>
              </div>
            </div>-->
      </div>
    </div>
<!--    edit schedule modal-->
    <div class="modal fade " id="publishModel" tabindex="-1" role="dialog" aria-labelledby="publishModelLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content absence-model publishModel ">
          <div class="modal-header">
            <h5 class="modal-title">Are you sure you want to edit your schedule?
            </h5>
            <p></p>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <p>You are changing your schedule state from published back into planning. Use the planning tool to edit your schedule.</p>
            <h5 class="modal-title sub-heading" id="publishModelLabel">IMPORTANT: When you are editing your schedule:</h5>
            <ul class="publish-sch">
              <li>Your employees can still see their current shifts.</li>
              <li>You employees can’t swap shifts.</li>
              <li>Your employees can’t write messages</li>
              <li>Your employees can’t edit their attendance</li>
            </ul>
          </div>
          <div class="modal-footer">
            <a href="#" class="btn btn-outline-warning btn-sm" data-dismiss="modal"
               aria-label="Close">Cancel</a>
            <button @click="editScheduleFun" class="btn btn-outline-primary btn-sm">Edit Schedule</button>
          </div>
        </div>
      </div>
    </div>
    <!-- add new modal -->
    <div class="modal fade write-msg-model creat-employee-modal cardModal" id="cardModal" v-show="addNewShiftModal" tabindex="-1" role="dialog" aria-labelledby="write-msg-modelLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">
              <h5></h5>
              <p class="">Add New Shift  </p>
            </div>
            <button
              type="button"
              class="close"
              ref="closeModal"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="scrolling">
              <div class="inputs-wrapper">
                <div class="inputs-holder">
                  <div class="field-col big-date-pik">
                    <label>Pick a date </label>
<input type="date" v-model="scheduleForm.date" class="form-control">
<!--                    <date-picker v-model="scheduleForm.date" value-type="format" format="YYYY-MM-DD"></date-picker>-->
                  </div>
                </div>
                <div class="inputs-holder">

                  <div class="field-col">
                    <label>Start Time</label>
                    <input type="time" class="form-control" v-model="scheduleForm.start_time" />
<!--                    <date-picker v-model="scheduleForm.start_time" :minute-step="15"  format="HH:mm" value-type="format" type="time" placeholder="HH:mm"></date-picker>-->
                  </div>
                  <div class="field-col">
                    <label>End Time</label>
<input type="time" class="form-control" v-model="scheduleForm.end_time" />
<!--                    <date-picker v-model="scheduleForm.end_time" :minute-step="15"  format="HH:mm" value-type="format" type="time" placeholder="HH:mm"></date-picker>-->
                  </div>
                  <div class="field-col">
                    <label for="exampleFormControlSelect1">Break Time</label>
                    <div class="nav-selectdrop">
                      <select  v-model="scheduleForm.break_time"
                        id="inputState"
                        class="form-control"
                      >
                        <option selected="">Select</option>
                        <option :value="20">20 Min</option>
                        <option :value="30">30 Min</option>
                        <option :value="40">40 Min</option>
                        <option :value="60">60 Min</option>
                      </select>
                    </div>
                  </div>
                  <div class="field-col">
                    <label for="exampleFormControlSelect1">Job Roles</label>
                    <div class="nav-selectdrop">
<!--                      <select
                        id="inputState"
                        class="form-control"
                      >
                        <option selected="selected">Data entry</option>
                        <option>News</option>
                        <option>Manager</option>
                      </select>-->
                      <select id="job-role" v-model="scheduleForm.job_role_id"
                              @change="getEmployeeByJobRoleChange($event)" class="form-control  ">
                        <option>Select</option>
                        <option v-if="jobTypes.length>0" v-for="value in jobTypes" :value="value.id">
                          {{ value.name }}
                        </option>

                      </select>


                    </div>
                  </div>
                  <div class="field-col">
                    <label for="exampleFormControlSelect1">Employes</label>
                    <div class="nav-selectdrop">
<!--                      <select
                        id="inputState"
                        class="form-control"
                      >
                        <option selected="selected">Data entry</option>
                        <option>News</option>
                        <option>Manager</option>
                      </select>-->
                      <select id="employee" v-model="scheduleForm.employee_id"
                              class="form-control text-capitalize ">
                        <option value="">Open Shift</option>
                        <option :value="jobTypesEmployees.adminDetail.employee.id" v-if="jobTypesEmployees.adminDetail">{{jobTypesEmployees.adminDetail.employee.name}}</option>
                        <option class="text-capitalize" v-if="jobTypesEmployees.employees.length>0"
                                v-for="value in jobTypesEmployees.employees"
                                :value="value.employee.id">{{ value.employee.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="field-col">
                    <label>Note (optional)</label>
                    <input type="text" v-model="scheduleForm.comment" class="form-control">
                  </div>
                </div>
                <div class="text-danger" v-text="new_job_role_name_error"></div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0)"
              class="btn btn-outline-warning btn-sm f-bold"
              data-dismiss="modal"
            >Cancel</a
            >
            <button
              type="button"
              class="btn btn-outline-primary btn-sm f-bold"
              data-dismiss="modal"
              @click="shiftSaveFunc(scheduleForm.date)"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import weeklyDatepicker from "./datepicker";
import messages from "./partials/messages";
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import axios from "axios";
import jobRolesFilter from "./partials/jobRolesFilter";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import Swal from "sweetalert2";
export default {
  name: 'signup',
  components: {
    'weeklyDatepicker': weeklyDatepicker,
    'messages': messages,
    'DatePicker': DatePicker,
    'jobRolesFilter': jobRolesFilter,ClipLoader
  },
  data() {
    return {
      sizeMain: '35px',
      spinnerColor: '#00779C',
      loadingSpinMain: false,
      weekNoDate: [],
      scheduleNameShow: false,
      addNewShiftModal: false,
      mainShiftActionTab: false,
      shiftActionTab: false,
      activeItem: null,
      dateParam: this.$route.params.date,
      currencySymbol: (this.$store.getters.getSelectedCompany.currency) ? this.$store.getters.getSelectedCompany.currency.symbol : 'Rs',
      filterActiveCus: false,
      isScheduleName: false,
      schedule_name: '',
      byWeekly: 1,
      selected: 1,
      company_id: this.$store.getters.getSelectedCompany.id,
      isModalVisible: false,
      isEditModalVisible: false,
      currentDate: moment(new Date()).format('YYYY-MM-DD'),
      startWeek: moment().weekday(1),
      endWeek: moment().weekday(7),
      // selectedDate: moment().weekday(1).format('YYYY-MM-DD') + '  ' + moment().weekday(7).format('YYYY-MM-DD'),
      selectedDate: [moment().weekday(1).format('YYYY-MM-DD'), moment().weekday(7).format('YYYY-MM-DD')],
      listProducts: '',
      date: new Date(),
      otherdate: new Date(),
      showCalendar: false,
      showCalendar1: false,
      roster_schedule_id: this.$route.params.id,
      employees: [],
      employee_id:'',
      schedule: [],
      weeksDates: [],
      weeksDatesByWeek: [],
      newarray: [],
      jobTypes: [],
      withoutjobTypesEmployees: [],
      jobTypesEmployees: [],
      copySchedulesByDateArray: [],
      schedule_ids: [],
      scheduleForm: {
        published: 1,
        date: '',
        start_time: '',
        end_time: '',
        break_time: '',
        job_role_id: '',
        employee_id: '',
        company_id: this.$store.getters.getSelectedCompany.id,
        comment: '',
      },
      selectedShift: 0,
      shiftNeedAssignment: 0,
      hoursAssigned: 0,
      minutesAssigned: 0,
      availableShiftHours: 0,
      availableShiftMinutes: 0,
      totalHoursPerEmp: 0,
      totalMinutesPerEmp: 0,
      totalHoursPerEmployeeList: [],
      newDateNext: '',
      newJobRoleNameForm: false,
      new_job_role_name: '',
      new_job_role_name_error: '',
      totalCostByDate: [],
      totalCost: [],
      employeeShiftHours: [],
      makeItAvalibaleShift:'',
      makeItAvalibaleShiftDate:'',
      attendanceForm:[],
      punchInTime:'',
      punchOutTime:'',
      punchInNote:'',
      punchOutNote:'',
      errorText:'',
      saveBtnDisable:false
    }
  },

  created() {
    this.main();
    this.getJobType();
  },

  methods: {
    scheduleNameBtnClick(){
      this.scheduleNameShow= true;
    },
    scheduleNameCancelBtnClick(){
      this.scheduleNameShow= false;
    },
    scheduleNameSaveBtnClick(id){

      axios.post(this.$UpdateScheduleName,
        {
          id: id,
          name: this.schedule_name,
          company_id: this.company_id,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.data.status === 200) {
            $root.$toast.success("Updated");
          }
          this.scheduleNameShow=false;
          //Perform Success Action
        });
    },
    getRespondClassMatchRole(selectedValue,itemValue){
      return selectedValue === itemValue ? 'matchShiftClass' : 'matchShiftClassNew'
    },
    getRespondClassMatchAvailable(selectedValue,itemValue){
      return selectedValue === itemValue ? 'matchShiftClass' : 'matchShiftClassNew'
    },
    getRespondClassMatchOnDuty(selectedValue,itemValue,item,day,currentDate){
      return   item.attendance ? item.attendance.punch_in_time && item.attendance.punch_out_time==null && day===currentDate && selectedValue === itemValue ? 'matchShiftClass' : 'matchShiftClassNew':''
    },
    getRespondClassActiveItem(day,info,keyInt,activeItem){
      return   day+info.start_time+info.end_time+keyInt === activeItem ? 'matchShiftClass' : 'matchShiftClassNew'
    },

    timeFormat(time){
      return moment(time).format('HH:mm');
    },
    cancelAction(){
      this.mainShiftActionTab=false
    },
    goToweek(){
      this.$router.push({path:'/schedule/publish/'+this.roster_schedule_id+'/weeks'});
    },
    addNewShift(date,startTime,endTime){
     // console.log(date,startTime,endTime);
      this.addNewShiftModal=true;
      this.scheduleForm.date=date;
      this.scheduleForm.start_time=startTime;
      this.scheduleForm.end_time=endTime;
      this.scheduleForm.break_time= '';
      this.scheduleForm.job_role_id= '';
      this.scheduleForm.employee_id= '';
      this.scheduleForm.comment= '';

     // console.log(date,startTime,endTime,'selected params');
      $(".cardModal").modal("show");
    },
    selectShiftItem(i) {
      this.activeItem = i;
    //  console.log(this.activeItem);
    },
    selectShiftActionBtn(val,id,employee,date,jobRoleId,startShitTime,endShiftTime,type) {

      this.mainShiftActionTab = true;
      this.shiftActionTab = val;
      if(type==='makeitavailable' || type==='handover'){

        if(employee){
          var empId=employee.id;
        }else{
          var empId=0;
        }

        // this.availableShiftAssignModal(id,empId,date,jobRoleId);
      }
      if(type=='editshift'){

        this.editShift(id);
      }
      if(type=='attendanceMark'){
        this.editShift(id,val,employee,date,jobRoleId,startShitTime,endShiftTime,type);
      }
    },
    availableShiftAssignModal(id,empId,date,jobRoleId){
      this.makeItAvalibaleShift=id;
      this.makeItAvalibaleShiftDate=date;
      // this.getEmployees(id,empId);
      this.getEmployeeByJobRoleId(jobRoleId);
      this.getEmployeeWithOutByJobRoleId(jobRoleId);
    },
    handOverShiftFun(){
      axios.post(this.$handOverShiftAvailable,
        {
          id: this.makeItAvalibaleShift,
          date: this.makeItAvalibaleShiftDate,
          employee_id: this.employee_id,
          company_id: this.company_id,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.data.status == 200) {
            this.main();
            $root.$toast.success("Request success");
          }
          this.mainShiftActionTab=false;
          //Perform Success Action
        });
    },
    availableShiftModal(id){
      this.makeItAvalibaleShift=id;
      $('#availableShiftModel').modal('show');
    },
    makeItAvailableShiftFun(id){
        axios.post(this.$makeItShiftAvailable,
          {
            id: id,
            company_id: this.company_id,
          }, {headers: this.getAuthHeader()})
          .then((res) => {
            if (res.data.status == 200) {
              this.main();
              $root.$toast.success("Request success");
            }
            this.mainShiftActionTab=false;
            //Perform Success Action
          });

    },
    editScheduleFun(){
      $('#publishModel').modal('hide');
      axios.post(this.$SchedulesStatusUpdate,
        {
          status: '2',
          roster_schedule_id: this.roster_schedule_id,
          company_id: this.company_id,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.status == 200) {
            this.$router.push({path:'/schedule/'+this.roster_schedule_id});
          }
        });

    },
    getEmployees(id,empId) {
      this.$axios({
        method: "get",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id,
          filter_by: "EMPLOYEE"
        },
        url: this.$GetEmployees,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.data.status == 200) {
          this.employees=[];
          var filteredEmployees = res.data.result;
          filteredEmployees.filter(item => {
            if(item.id != empId){
              this.employees.push(item)
            }
          });
          // this.employees =res.data.result;
        }
      });
    },
    editShiftFun(){
      $('#publishModel').modal('hide');
      axios.post(this.$SchedulesStatusUpdate,
        {
          status: '2',
          roster_schedule_id: this.roster_schedule_id,
          company_id: this.company_id,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.status == 200) {
            this.$router.push({path:'/schedule/'+this.roster_schedule_id});
          }
        });

    },
    refreshJobRoles() {
      this.$root.$emit('refreshJobRoles');
    },
    hourlyPriceCalculate(hourlyRate, startTime, endTime, name, breakTime,date) {
      return this.getHourlyPriceCalculate(hourlyRate, startTime, endTime, name, breakTime,date);
    },
    //-----------------next button click -----------
    filterFunction(id) {
      if (id == 0 || id == '') {
        this.filterActiveCus = false;
      } else {
        this.filterActiveCus = true;
      }
      this.selectedShift = id;
    },
    addShiftBtn() {
      this.scheduleForm.date = "";
      this.scheduleForm.start_time = '';
      this.scheduleForm.end_time = '';
      this.scheduleForm.break_time = '';
      this.scheduleForm.job_role_id = '';
      this.scheduleForm.employee_id = '';
      this.scheduleForm.company_id = '';
      this.scheduleForm.comment = '';
      this.isModalVisible = true;
    },
    editShift(id,val,employee,date,jobRoleId,startShitTime,endShiftTime,type) {
      this.errorText      = '';
      this.saveBtnDisable = false;
      axios.get(this.$Schedule + '/' + id + '/edit', {
        headers: this.getAuthHeader(),
      })
        .then(res => {
          if (res.data.status == 200) {
            this.scheduleForm = res.data.result;
            this.getEmployeeByJobRoleId(this.scheduleForm.job_role_id);
            this.getEmployeeWithOutByJobRoleId(this.scheduleForm.job_role_id);
            if(type=='attendanceMark'){
              this.getAttendanceShift(id,employee.id,date,startShitTime,endShiftTime);
            }

          }
        });
    },
    getAttendanceShift(id,employee_id,date,startShitTime,endShiftTime) {
      axios.get(this.$AttendaceBySchedule , {
        headers: this.getAuthHeader(),
        params: {
          schedule_id: id,
          employee_id: employee_id,
          company_id: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.attendanceForm=res.data.result;
            this.attendanceForm = this.attendanceForm.map((atd) => {
              atd.punchIn   = moment(atd.punch_in_time).format('HH:mm');
              atd.punchOut  = moment(atd.punch_out_time).format('HH:mm');
              return atd;
            });
            this.punchInTime = moment(this.scheduleForm.date+' '+this.scheduleForm.start_time).format('HH:mm');
          }
        });
    },
    validateTime(event,timing){
      this.errorText      = '';
      this.saveBtnDisable = false;
      $(event.target).css("border-color","#e6e6e6");
      if(this.scheduleForm.is_floating_shift==0){
        let shiftStartTime  = new Date(this.scheduleForm.date+' '+this.scheduleForm.start_time).getTime();
        let shiftEndTime    = new Date(this.scheduleForm.date+' '+this.scheduleForm.end_time).getTime();
        let attendTime      = new Date(this.scheduleForm.date+' '+event.target.value).getTime();
        /*if(timing=='start' && attendTime<shiftStartTime){
          $(event.target).css("border-color","red");
          this.errorText      = 'Punch in time must be equal or greater than shift time.';
          this.saveBtnDisable = true;
        }*/
        /*else if(timing=='end' && attendTime>shiftEndTime){
          $(event.target).css("border-color","red");
          this.errorText      = 'Punch out time must be equal or less than shift time.';
          this.saveBtnDisable = true;
        }*/
      }
    },
    deleteSchedule(id) {
      new Swal({
        title: "Delete Shifts?",
        icon: "warning",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => {
        if (result.value) {
          axios.delete(this.$Schedules + '/' + id,
            {headers: this.getAuthHeader()})
            .then((res) => {
              if (res.status == 200) {
                this.mainShiftActionTab=false;
                this.main();
              }
            });
        }})

    },
    updateSchedule(id) {
      axios.put(this.$Schedules + '/' + id,
        {
          published: this.scheduleForm.published,
          date: this.scheduleForm.date,
          start_time: this.scheduleForm.start_time,
          end_time: this.scheduleForm.end_time,
          break_time: this.scheduleForm.break_time,
          job_role_id: this.scheduleForm.job_role_id,
          employee_id: this.scheduleForm.employee_id,
          is_floating_shift: this.scheduleForm.is_floating_shift,
          company_id: this.company_id,
          comment: this.scheduleForm.comment,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.status === 200) {
             $root.$toast.success("Updated successfully");
            this.main();
            this.mainShiftActionTab=false;
          }
        });
    },
    attendanceMarkShift(id) {
      if(this.attendanceForm && this.attendanceForm.length==0){
        let start = new Date(this.scheduleForm.date+' '+this.punchInTime).getTime();
        let end   = null;
        if(this.punchOutTime){
          end = new Date(this.scheduleForm.date+' '+this.punchOutTime).getTime();
          end = start>end?end+(1000*60*60*24):end;
        }
        this.attendanceForm = [{
            punch_in_time   : moment(this.scheduleForm.date+' '+this.punchInTime).format('YYYY-MM-DD HH:mm'),
            punch_out_time  : (end)?moment(new Date(end)).format('YYYY-MM-DD HH:mm'):null,
            punch_in_note   : this.punchInNote,
            punch_out_note  : this.punchOutNote,
        }];
      }else{
        this.attendanceForm = this.attendanceForm.map((atd) => {
          let start = new Date(this.scheduleForm.date+' '+atd.punchIn).getTime();
          let end   = null;
          if(atd.punchOut){
            end = new Date(this.scheduleForm.date+' '+atd.punchOut).getTime();
            end = start>end?end+(1000*60*60*24):end;
          }
          atd.punch_in_time   = moment(new Date(start)).format('YYYY-MM-DD HH:mm');
          atd.punch_out_time  = (end)?moment(new Date(end)).format('YYYY-MM-DD HH:mm'):null;
          return atd;
        });
      }
      this.scheduleForm.attendances = this.attendanceForm;
      axios.post(this.$UpdateShiftTime,
        {shift:this.scheduleForm}, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.status === 200) {
            $root.$toast.success(res.data.message);
            this.main();
            this.mainShiftActionTab=false;
            new Swal({
              title: "Success",
              icon: "success",
              text: "Attendance updated successfully.",
              type: "success",
              confirmButtonText: "Ok"
            })
          }
        });


    },

    calculateWeeksDays(date) {
      // let curr = new Date(date);
      var days = moment(this.endWeek).diff(moment(this.startWeek), 'days');
      var difWeek = moment(this.endWeek).diff(moment(this.startWeek), 'week');
      //console.log(difWeek,'difWeek');
      let weekDd=moment(this.startWeek ).weekday(1).format('YYYY-MM-DD');
      this.byWeekly = difWeek + 1;
      this.newDateNext = weekDd;
      for (let i = 1; i <= difWeek + 1; i++) {
        let curr = new Date(this.newDateNext);
        var newDate = moment(curr).add(-1, 'd').format('YYYY-MM-DD');
        // console.log(newDate,'==newDate');
        newDate = moment(newDate);
        this.weeksDatesByWeek[i] = Array(7).fill().map(
          () => newDate.add(1, 'd').format('YYYY-MM-DD')
        );
        this.newDateNext = moment(newDate).add(1, 'd');
        this.otherdate = moment(curr).add(6, 'd').format('YYYY-MM-DD');
        this.showCalendar = false;
      }
      this.getByWeekly(difWeek + 1);
      //  console.log( this.weeksDatesByWeek);
    },
    getByWeekly(length) {
      this.byWeekly = length;
    },
    getJobType() {
      axios
        .get(this.$GetJobRulesType, {
          headers: this.getAuthHeader(),
          params: {
            company_id: this.company_id,
          }
        })
        .then(res => {
          if (res.data.status == 200) {
            this.allJobTypes = res.data.result;
            this.jobTypes = this.allJobTypes;
          }
        });
    },
    getEmployeeByJobRoleChange(event) {
      if (event.target.value == 'new') {
        this.newJobRoleNameForm = true;
        return 1;
      } else {
        this.jobTypesEmployees = [];
        axios.get(this.$GetEmployeesByJobRolesType, {
          headers: this.getAuthHeader(),
          params: {
            job_role_id: event.target.value,
            company_id: this.company_id,
          }
        })
          .then(res => {
            if (res.data.status == 200) {
              this.jobTypesEmployees = res.data.result;
            }
          });

      }
    },

    getEmployeeByJobRoleId(id) {

      axios.get(this.$GetEmployeesByJobRolesType, {
        headers: this.getAuthHeader(),
        params: {
          job_role_id: id,
          company_id: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status == 200) {

            this.jobTypesEmployees = res.data.result;
          }
        });
    },
    getEmployeeWithOutByJobRoleId(id) {
      axios.get(this.$GetmployeeWithOutByJobRoleId, {
        headers: this.getAuthHeader(),
        params: {
          job_role_id: id,
          company_id: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.withoutjobTypesEmployees = res.data.result;
          }
        });
    },
    shiftSaveFunc(date) {
      this.scheduleForm.date = date;
      this.submitForm();
       $('#cardModal').modal('hide')

       this.scheduleForm.break_time= '';
        this.scheduleForm.job_role_id= '';
        this.scheduleForm.employee_id= '';
        this.scheduleForm.comment= '';

    },
    closeModalBtnEdit() {
      this.isEditModalVisible = false;
    },
    submitForm() {
      if (this.scheduleForm.date == '') {
        return 1;
      }
      axios.post(this.$Schedules,
        {
          start_date: moment(this.startWeek).format('YYYY-MM-DD'),
          end_date: moment(this.endWeek).format('YYYY-MM-DD'),
          roster_schedule_id: this.roster_schedule_id,
          published: this.scheduleForm.published,
          date: this.scheduleForm.date,
          start_time: this.scheduleForm.start_time,
          end_time: this.scheduleForm.end_time,
          break_time: this.scheduleForm.break_time,
          job_role_id: this.scheduleForm.job_role_id,
          employee_id: this.scheduleForm.employee_id,
          company_id: this.company_id,
          comment: this.scheduleForm.comment,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.data.status === 200) {
            if(res.data.result !=''){
              this.roster_schedule_id = res.data.result.roster_schedule_id;
              $root.$toast.success("Created successfully");
              this.main();
            }
          }
        });
    },

    main() {
      this.loadingSpinMain= true;
      let params = {
        company_id: this.company_id,
        roster_schedule_id: this.roster_schedule_id,
        start_date: moment(this.startWeek).format('YYYY-MM-DD'),
        end_date: moment(this.endWeek).format('YYYY-MM-DD')
      };
      if (this.$route.params.id == undefined) {
        this.calculateWeeksDays(this.startWeek);
      }
      this.$axios.get(this.$Schedule, {
        params: params,
        headers: this.getAuthHeader(),
      }).then(response => {
        this.loadingSpinMain= false;
        if (response.status == 200) {

          this.schedule_name = (response.data.result.name)?response.data.result.name:moment(response.data.result.start_date).format('D MMMM Y')+' ~ '+moment(response.data.result.end_date).format('D MMMM Y');
          this.weekStartDate = response.data.result.start_date;
          this.weekEndDate = response.data.result.end_date;
          this.startWeek = response.data.result.start_date;
          this.endWeek = response.data.result.end_date;
          this.selectedDate = [moment(this.weekStartDate).format('YYYY-MM-DD'), moment(this.weekEndDate).format('YYYY-MM-DD')];
          this.calculateWeeksDays(this.weekStartDate);
          this.employeeShiftHours = response.data.result.employeeShiftHours;
          this.schedule = response.data.result.schedules;
          var difWeek = moment(response.data.result.end_date).diff(moment(response.data.result.start_date), 'week');
          this.byWeekly = difWeek + 1;
          this.getByWeekly(difWeek + 1);
          var totalCost = 0;
          for (let week = 1; week <= difWeek + 1; week++) {
            // this.byWeekly.forEach(week => {
            this.totalCostByDate[week] = [];
            this.weekNoDate[week]=[];
            this.weeksDatesByWeek[week].forEach((wd,key) => {
              if(key==0){
                this.weekNoDate[week].push(wd);
              }
              // this.weeksDatesByWeek[week].push(wd);
              this.newarray[week + wd] = [];
              this.schedule.forEach((sc, key) => {
                if (wd == sc.date) {
                  if (sc.mark_deleted == 0) {
                    this.schedule_ids.push(sc.id);
                    //------------- calculate total date cost-------------------
                    const maxWorkdaysInRow = this.newarray[week + wd].findIndex(el => el.start_time == sc.start_time & el.end_time == sc.end_time);
                    if (maxWorkdaysInRow < 0) {
                      this.newarray[week + wd].push(sc);
                    }
                  }
                }
              });
            });
          }

        }

      });

    },

    currencyAmountFormat(value) {
      return this.currencyFormatter(value);
    }

  }
}
</script>

<style>
/*.sheduel-date-list .sheduel-li-row .li-row-rgt{
  max-height: 0;
  overflow: hidden;
}
.sheduel-date-list .sheduel-li-row .li-row-rgt.activeActionShift{
  max-height: 999px;
  overflow: visible;
}*/
.activeActionShift{
  display: block !important;
}
.btn {
  position: reltive;
}


.overlayer-input input {
  width: 100%;
  margin-right: 10px;

}

.week-table .mini-card .card-body h4 {
  line-height: 18px !important;
}

.spinnerCustom .v-spinner {
  position: absolute;
  margin: 0 auto;
  width: 100%;
  z-index: 1111111;
  top: 50%;
}
.text-red{
  color: red;
}

</style>
